import {NotificationManager} from 'react-notifications';

// Powiadomienia nie znikają same (WCAG 2.2.1) – zamyka je kliknięcie albo klawisz Escape.
const BEZ_LIMITU_CZASU = 0;

export const zamknijWszystkiePowiadomienia = () => {
    NotificationManager.listNotify.slice().forEach((powiadomienie: any) => NotificationManager.remove(powiadomienie));
};

// Nowe powiadomienie zastępuje poprzednie, żeby trwałe komunikaty się nie kumulowały.
export const notify = {
    info(message: string, title: string) {
        zamknijWszystkiePowiadomienia();
        NotificationManager.info(message, title, BEZ_LIMITU_CZASU);
    },
    error(message: string, title: string) {
        zamknijWszystkiePowiadomienia();
        NotificationManager.error(message, title, BEZ_LIMITU_CZASU);
    }
};

export const obslugaEscape = (e: KeyboardEvent) => {
    if (e.key === 'Escape' || e.key === 'Esc') {
        zamknijWszystkiePowiadomienia();
    }
};
